
import { defineComponent, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
export default defineComponent({
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props: any) {
    const route = useRoute()
    const pageData: any = ref([])
    const currentpage: any = (route.meta || {}).page || '[]'

    pageData.value = props.data
    watch(
      () => route.name,
      () => {
        const dom: any = document.querySelector('.content')
        const currentpage: any = (route.meta || {}).page || '[]'
        pageData.value = JSON.parse(currentpage)
        dom.scrollTop = 0
      },
      { deep: true }
    )
    return {
      pageData
    }
  }
})
